import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { ApiService } from './api.service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class QuotaSalesService extends ApiService {
  constructor(private http: Http) {
    super('api/quota-sales/', http);
  }

  getQuotaSales(params: string) {
    const url = `${this.apiUrl}api/quotas-sales/?${params}`;
    return this.http
      .get(url, { headers: this.getHeaders() })
      .map((res: any) => this.extractData(res))
      .catch((e) => this.handleError(e));
  }

  getGroupedQuotaSales(params: string = '') {
    const url = `${this.apiUrl}api/quotas-sales-grouped/?${params}`;
    return this.http
      .get(url, { headers: this.getHeaders() })
      .map((res: any) => this.extractData(res))
      .catch((e) => this.handleError(e));
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/quota-sales.service.ts